export const getUserIdKey = () => `authUserId`

export const getClinicIdKey = (userId: string | number | null) =>
  `authUserId-${String(userId)}`
